import React, { useState, useEffect, useMemo } from "react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Container,
  InputSearch,
  Content,
  ButtonAction,
  Description,
  LinkContainer,
  Center,
  ContainerPaginate,
  LoaderContainer,
} from "./styled";
import { Button, Icon, Modal, Pagination } from "semantic-ui-react";
import { producaov2, local } from "../../../services/apis";
import { SemanticTable } from "../ControleIndicacoes/styles";
import ModalCreatePlan from "../../../components/Admin/Pagarme/ModalCreatePlan";
import { Dimmer, Loader } from "semantic-ui-react";
import { PLAN_PAYMENT_METHODS } from "../../../constants";
import { getUserNode } from "../../../services/auth_node";
import { financialUsers, TIUsers } from "../../../utils/Utils";

const interval = {
  mensal: "meses",
  anual: "anos",
};

const Planos = () => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [modalPlan, setModalPlan] = useState(false);
  const [planSelected, setPlanSelected] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPlans, setTotalPlans] = useState(0);

  const itemsPerPage = 20;

  const user = getUserNode();
  const allowedSpecialLinksEmails = [
    ...TIUsers,
    ...financialUsers.filter(
      (email) => email !== "amanda.pires@voitto.com.br"
    ),
  ];
  const canViewSpecialLinks = allowedSpecialLinksEmails.includes(user?.email);

  const getPlans = async (page = currentPage) => {
    setLoading(true);

    const params = {
      page,
      pageSize: itemsPerPage,
    };

    if (search) {
      params.search = search;
    }

    await producaov2
      .get("/admin/planos/assinatura", { params })
      .then((response) => {
        const allPlans = response.data?.data || [];
        const filtered = allPlans.filter((plan) => {
          if (canViewSpecialLinks) return true;
          const isSpecialLink =
            plan?.dias_teste > 0 || plan?.payment_methods?.includes("boleto");
          return !isSpecialLink;
        });

        setPlans(filtered);
        setTotalPlans(response.data?.total || 0);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = () => {
    setCurrentPage(1);
    getPlans(1);
  };

  const handlePageChange = (event, { activePage }) => {
    setCurrentPage(activePage);
  };

  const handleCopyLink = (id) => {
    const url = `https://voitto.com.br/inscricao/plano/${id}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        setPlanSelected(null);
        swal("Link copiado com sucesso");
      })
      .catch(() => {
        swal("Não foi possível copiar o link");
      });
  };

  const renderDescription = (plan) => {
    const intervaloTime = (() => {
      if (!plan.ciclos_cobranca) {
        return "indefinidas vezes";
      }

      return `${plan.ciclos_cobranca} ` + interval[plan.intervalo_cobranca];
    })();

    return (
      <Description>
        Descrição:
        <p>
          Essa assinatura vai cobrar por <strong>{intervaloTime}</strong> o
          valor de <strong>R${plan.valor}</strong> em um intervalo{" "}
          <strong>{plan.intervalo_cobranca}</strong> <br />
          Esse valor pode ser parcelado em até{" "}
          <strong>{plan.parcelamento}</strong> parcelas.
        </p>
        <p>
          Contas para convite: <strong>{plan.total_indicacoes}</strong>
        </p>
      </Description>
    );
  };

  useEffect(() => {
    getPlans(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (!modalPlan) {
      getPlans(currentPage);
    }
  }, [modalPlan]);

  const formattedPaymentMethods = useMemo(() => {
    return planSelected?.payment_methods
      ?.split(",")
      ?.map((method) => {
        const payment = PLAN_PAYMENT_METHODS.find(
          (paymentMethod) => paymentMethod.value === method
        );

        return payment.text;
      })
      ?.join(" | ");
  }, [planSelected]);

  if (loading) {
    return (
      <LoaderContainer>
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      </LoaderContainer>
    );
  }

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Content>
          <Center space>
            <h1>Planos Pagarme</h1>
            <Button
              type="button"
              color="blue"
              onClick={() => setModalPlan(true)}
            >
              Cadastrar novo plano
            </Button>
          </Center>
          <InputSearch className="ui fluid left icon input">
            <input
              placeholder="Busque pelo nome do plano, valor da parcela ou ID do curso"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
            <Icon name="search icon" />
            <button onClick={handleSearch}>
              Buscar
            </button>
          </InputSearch>

          <SemanticTable>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Id Plano</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Valor da parcela
                </SemanticTable.HeaderCell>
                {/* <SemanticTable.HeaderCell>Intervalo </SemanticTable.HeaderCell> */}
                <SemanticTable.HeaderCell>
                  Ciclos de cobrança
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Cobrança Futura
                </SemanticTable.HeaderCell>
                {/* <SemanticTable.HeaderCell>
                  parcelamento
                </SemanticTable.HeaderCell> */}
                {/* <SemanticTable.HeaderCell>
                  Contas para convite
                </SemanticTable.HeaderCell> */}
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {plans
                .map((plan, index) => (
                  <SemanticTable.Row
                    key={index}
                    negative={plan.dias_teste != 0}
                  >
                    <SemanticTable.Cell>{plan.id_plano}</SemanticTable.Cell>
                    <SemanticTable.Cell>{plan.nome} </SemanticTable.Cell>
                    <SemanticTable.Cell>R${plan.valor}</SemanticTable.Cell>
                    {/* <SemanticTable.Cell>
                      {plan.intervalo_cobranca}
                    </SemanticTable.Cell> */}
                    <SemanticTable.Cell>
                      {plan.ciclos_cobranca || "Indefinida vezes"}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {plan.dias_teste ? `${plan.dias_teste} dias` : "Imediata"}
                    </SemanticTable.Cell>
                    {/* <SemanticTable.Cell>{plan.parcelamento}</SemanticTable.Cell> */}
                    {/* <SemanticTable.Cell>
                      {" "}
                      {plan.total_indicacoes}
                    </SemanticTable.Cell> */}
                    <SemanticTable.Cell>
                      <ButtonAction onClick={() => setPlanSelected(plan)}>
                        Ver Mais
                      </ButtonAction>
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
            </SemanticTable.Body>
          </SemanticTable>
          <ContainerPaginate>
            <Pagination
              boundaryRange={0}
              activePage={currentPage}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              totalPages={Math.ceil(totalPlans / itemsPerPage)}
              onPageChange={handlePageChange}
            />
          </ContainerPaginate>
          {planSelected && (
            <Modal
              closeIcon
              open={!!planSelected}
              onClose={() => setPlanSelected(null)}
            >
              <Modal.Content>
                <h3>Plano de assinatura</h3>
                <div>
                  Plano: <p>{planSelected.nome}</p>
                  Curso: <p>{planSelected.curso}</p>
                  {planSelected?.payment_methods && (
                    <>
                      Formas de pagamento: <p>{formattedPaymentMethods}</p>
                    </>
                  )}
                  {renderDescription(planSelected)}
                  <LinkContainer>
                    <p>LINK:</p>
                    <div>
                      <a
                        href={`https://voitto.com.br/inscricao/plano/${planSelected.id_plano}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://voitto.com.br/inscricao/plano/
                        {planSelected.id_plano}
                      </a>
                      <button
                        onClick={() => handleCopyLink(planSelected.id_plano)}
                      >
                        <Icon name="copy" />
                        Copiar link
                      </button>
                    </div>
                  </LinkContainer>
                </div>
              </Modal.Content>

              <Modal.Actions>
                <ButtonAction
                  onClick={() => setPlanSelected(null)}
                  color="red"
                  inverted
                >
                  <Icon name="close" /> Fechar
                </ButtonAction>
              </Modal.Actions>
            </Modal>
          )}
          <ModalCreatePlan open={modalPlan} handleClose={setModalPlan} />
        </Content>
      </Container>
    </div>
  );
};

export default Planos;
